import React, { useState } from "react";
import Image, { StaticImageData } from "next/image";
import { useMusicPlayer } from "@/providers/music-provider/music-provider";

type VoicePlayButtonProps = {
  baseIcon: StaticImageData;
  hoverIcon: StaticImageData;
  activeIcon: StaticImageData;
  url: string;
  size?: number;
};

const VoicePlayButton = ({
  baseIcon,
  hoverIcon,
  activeIcon,
  url,
  size,
}: VoicePlayButtonProps) => {
  const { playTrack, isPlaying, currentTrack, pauseTrack } = useMusicPlayer();
  const [isHover, setIsHover] = useState(false);

  const onMouseEnter = () => setIsHover(true);
  const onMouseLeave = () => setIsHover(false);
  const handlePlayButtonClick = () => {
    if (isCurrentTrackPlaying) {
      pauseTrack();
      return;
    }
    playTrack(url, 0, [url]);
  };
  const isCurrentTrackPlaying = currentTrack === url && isPlaying;

  const icon = isCurrentTrackPlaying
    ? activeIcon
    : isHover
      ? hoverIcon
      : baseIcon;
  return (
    <>
      <Image
        width={size ? size : 20}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onClick={(e) => {
          e.stopPropagation();
          handlePlayButtonClick();
        }}
        src={icon}
        alt="play-pause"
      />
    </>
  );
};

export default VoicePlayButton;
